export enum EHistoryEntityType {
  ORDERS = 'orders',
  REQUESTS = 'requests',
  MULTIREQUEST = 'multirequests',
}
